export const noop = () => { };

// 复制到剪切板
export function clipboard(value: string): boolean {
  const input = document.createElement('input');
  input.setAttribute('readonly', 'readonly');
  input.setAttribute('value', value);
  document.body.appendChild(input);
  input.select();
  input.setSelectionRange(0, 9999);
  const res = document.execCommand && document.execCommand('copy');
  document.body.removeChild(input);
  return res;
}

export const isHttpsPage = (): boolean => window.location.protocol.startsWith('https');

export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms, ms));


export interface IDeferrer {
  promise: Promise<any>;
  resolve: (value: any) => void;
  reject: (value: any) => void;
}

export function defer(): IDeferrer {
  let _resolve = (value: any) => { };
  let _reject = (value: any) => { };

  const p = new Promise((resolve, reject) => {
    _resolve = resolve;
    _reject = reject;
  });

  return {
    promise: p,
    resolve: _resolve,
    reject: _reject,
  };
}


export function imageToBase64(url: string): Promise<string> {
  if (typeof document === 'undefined') {
    return Promise.resolve('');
  }
  let canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const img = new Image();
  // 解决Canvas.toDataURL 图片跨域问题
  img.crossOrigin = 'anonymous';

  return new Promise((resolve, reject) => {
    img.onload = () => {
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      // 获取到图片的格式
      const ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
      // 得到base64 编码的 dataURL
      const dataURL = canvas.toDataURL('image/' + ext);
      resolve(dataURL);
      canvas = null;
    };
    img.onerror = e => {
      reject(e);
      canvas = null;
    };
    img.src = url;
  });
}

export function throttle(fn: Function, wait = 100, tail = false) {
  let invoking = false;
  let timer: number | null = null;
  return function () {
    let args = arguments;
    let context = this;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (!invoking) {
      invoking = true;
      setTimeout(() => (invoking = false), wait);
      fn.apply(context, args);
    } else {
      // 尾调用 让方法在脱离事件后也能执行一次
      if (tail) {
        timer = window.setTimeout(() => {
          fn.apply(context, args);
        }, wait);
      }
    }
  };
}

export function debounce(fn: Function, wait = 100) {
  let timer: number | null = null;
  return function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    let args = arguments;
    let context = this;
    timer = window.setTimeout(() => {
      fn.apply(context, args);
    }, wait);
  };
}

export function loadImage(imageUrl: string): Promise<boolean> {
  const loadPromise: Promise<boolean> = new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = function () {
      resolve(true);
    };
    image.onerror = function () {
      reject(false);
    };
    image.onabort = function () {
      reject(false);
    };
    image.src = imageUrl;
  });
  return loadPromise;
};


export function getTimezone(): string {
  const d: Date = new Date();
  const offset: number = d.getTimezoneOffset();
  const sign: string = (offset < 0) ? '+' : '-';
  const hour: number = parseInt(Math.abs((offset / 60)).toFixed(0));
  const minute: number = parseInt(Math.abs((offset % 60)).toFixed(0));
  return `GMT${sign}${hour < 10 ? `0${hour}` : hour}:${minute < 10 ? `0${minute}` : minute}`;
}